import Image from 'next/image';
import CanvaDisabledIconImage from 'public/img/icons/canva_disabled_icon.svg';
import CanvaIconImage from 'public/img/icons/canva_icon.svg';

export function CanvaIcon({ width = 32 }: { width?: number }) {
  return <Image width={width} alt="" src={CanvaIconImage} />;
}

export function CanvaIconDisabled({ width = 32 }: { width?: number }) {
  return (
    <Image
      width={width}
      data-testid="canva-icon-disabled"
      alt=""
      src={CanvaDisabledIconImage}
    />
  );
}
